export default [
  {
    title: "Transaction Status",
    icon: "MapIcon",
    tagVariant: "light-warning",
    children: [
      {
        title: "by PNR",
        route: "PNR-Status",
        resource: "TransactionStatus",
        action: "View",
      },
      {
        title: "by TransactionID",
        route: "TransactionID-Status",
        resource: "TransactionStatus",
        action: "View",
      },
    ],
  },
];
